import { CollapsibleDataContainer } from 'components/reusable/CollapsibleDataContainer'
import { Banner } from 'slab'

import EmployerApplicationsTable from './EmployerApplicationsTable'

interface EmployerApplicationsViewProps {
  employerId: string
}

const EmployerApplicationsView = ({ employerId }: EmployerApplicationsViewProps) => {
  const successContent = (
    <div className='p-2'>
      <div className='mt-4 mb-4 p-3 bg-gray-50 rounded-md border border-gray-200'>
        <span className='font-bold text-md'>📄 What is this?</span>
        <br />
        <span>
          Financial applications are submitted to banking partners (like Unit) as part of the employer onboarding process. These applications track the status of account opening requests for business accounts and related financial services.
        </span>
      </div>
      <EmployerApplicationsTable employerId={employerId} />
    </div>
  )

  const errorContent = (
    <Banner title='Error loading financial applications. Please try again later.' />
  )

  return (
    <CollapsibleDataContainer
      heading={<span className='heading-md'>Financial Applications</span>}
      isLoading={false}
      error={false}
      localStorageKey='employer-applications-view'
      loadingContent={<div>Loading financial applications...</div>}
      errorContent={errorContent}
      successContent={successContent}
    />
  )
}

export default EmployerApplicationsView
